'use strict';

function MarketingLoanProductInterest() {
  this.id = null;
  this.node = null;

  this.el = {};

  this._classes = {
    selectAmount: 'js--select-amount',
    selectPurpose: 'js--select-purpose'
  };

  this.init = function () {};

  this.initAllReady = function () {
    this.el.$selectAmount = $('.' + this._classes.selectAmount);
    this.el.$selectPurpose = $('.' + this._classes.selectPurpose);

    this._storeUserPref();
  };

  this._storeUserPref = function () {
    var expiryDays = 30;

    // sets credit amount
    this.el.$selectAmount.on('change', function () {
      Cookies.set('formdata_profileinfo_loanInterest', 'true', { expires: expiryDays });
      var selectValue = this.value;
      Cookies.set('formdata_profileinfo_creditAmount', selectValue, { expires: expiryDays });
    });

    // sets purpose
    this.el.$selectPurpose.on('change', function () {
      Cookies.set('formdata_profileinfo_loanInterest', 'true', { expires: expiryDays });
      var selectValue = this.value;
      Cookies.set('formdata_profileinfo_creditPurpose', selectValue, { expires: expiryDays });
    });
  };
}